import { Component, OnInit } from '@angular/core';
import {ActivatedRoute, ParamMap, Router} from '@angular/router';
import { untilDestroyed } from '@app/@core';
import { EmbeddedURLRequestModel } from '@app/@shared/models/embedded-url-request.model';
import { UntilDestroy } from '@ngneat/until-destroy';
import {NavigationService} from '@shared/services/navigation/navigation.service';
import {PreviousPageService} from '@shared/services/previous-page.service';
import {moduleNameFromUrl} from '@shared/utils/common';
import { combineLatest } from 'rxjs';

@UntilDestroy()
@Component({
    selector: 'app-retool-back-navigation',
    templateUrl: './retool-back-navigation.component.html',
    styleUrls: ['./retool-back-navigation.component.scss'],
    standalone: false
})
export class RetoolBackNavigationComponent implements OnInit {
  title: string;
  tagNameList: string[];
  embeddedURLRequest: EmbeddedURLRequestModel

  constructor(
    private readonly route: ActivatedRoute,
    private readonly router: Router,
    private readonly navService: NavigationService,
    public prevPage: PreviousPageService,
  ) {}

  ngOnInit(): void {
    const moduleName = moduleNameFromUrl(this.router.url);

    this.route.paramMap.pipe(
      untilDestroyed(this)
    ).subscribe((paramMap) => {
        // We need to get params here given this component
        // could be used more than once with different params (dynamic routing with guards)
        this.embeddedURLRequest = {
          appId: paramMap.get('appId')
        };
        this.getSubscription(paramMap, moduleName);
    });
  }

  onClickBack(): void {
    this.prevPage.navigateBack()
  }

  private getSubscription(params: ParamMap, moduleName: string): void {
    combineLatest([
      this.navService.getSubscription(params.get('subscriptionId'), moduleName),
      this.navService.getNavigationElementById(params.get('appId'), moduleName)
    ]).pipe(
      untilDestroyed(this)
    ).subscribe(([subscriptionList, subscriptionName]) => {
      this.tagNameList = [subscriptionList.name];
      this.title = subscriptionName.name
    });
  }
}
